import { createFileRoute } from '@tanstack/react-router';
import { AccountingPeriodClosingPage } from '@/features/accounting/closing/components/AccountingPeriodClosingPage';

export const Route = createFileRoute('/$commiteeSlug/accounting/closing/{-$id}')({
  component: AccountingPeriodClosingPage,
});
